import styles from '../SimCommon.module.css'
import ModalWindow from "../../../ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import TableItem from "../../../FormTemplate/TableItem/TableItem";
import React from "react";
interface ISimLastPaymentProps
{
    onClose: ()=>void
    data: any[]
}

export default function SimLastPayment({onClose,data} :ISimLastPaymentProps)
{
    if(!data || !data?.length)return (
            <ModalWindow onClose={onClose}>
                <div className={styles.mainCont}>
                    <MainFormTemplate title={`Последние 10 платежей`} background={"white"} maxWidth={"300px"} onClose={onClose}>
                        <div className={styles.flexCenter}>Платежей нет</div>
                    </MainFormTemplate>
                </div>
            </ModalWindow>
    )

    return(
        <ModalWindow onClose={onClose}>
            <div className={styles.mainCont}>
                <MainFormTemplate title={`Последние 10 платежей`} background={"white"} maxWidth={"500px"} onClose={onClose}>
                    <div className={styles.flexCenter}>
                        <TableItem
                            data={data}
                            onPageCount={10}
                            column={[
                                {
                                    type: 2,
                                    maxLen: 20,
                                    fieldId:"date",
                                    title: "Дата",
                                    mode: "",

                                },
                                {
                                    type: 1,
                                    maxLen: 10,
                                    fieldId:"amount",
                                    title: "Сумма",
                                    mode: "",

                                },
                                {
                                    type: 0,
                                    maxLen: 20,
                                    fieldId:"idPay",
                                    title: "id",
                                    mode: "",

                                },
                                {
                                    type: 5,
                                    maxLen: 20,
                                    fieldId:"billed",
                                    title: "Проведен",
                                    mode: "",

                                },
                            ]}
                        ></TableItem>

                    </div>



                </MainFormTemplate>
            </div>
        </ModalWindow>
    )
}